import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import BMLogo from "../assets/bmlogo.png"; // ✅ your logo

const AboutPage = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div id="about" className="bg-[#fff9f8] w-screen max-w-none font-sans text-gray-800">
      {/* Header / About Section */}
      <section className="pt-20 md:py-20 px-6 md:px-20">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 items-center gap-10">
          {/* Left Side - Logo with Background Circles */}
          <div className="flex justify-center md:justify-start relative mb-10 md:mb-0" data-aos="zoom-in">
            <div className="relative w-48 sm:w-64 h-48 sm:h-64 flex items-center justify-center">
              {/* Background Circles */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="absolute w-[300px] sm:w-[400px] h-[300px] sm:h-[400px] rounded-full border border-[#F8B68B] opacity-50"></div>
                <div className="absolute w-[220px] sm:w-[290px] h-[220px] sm:h-[290px] rounded-full border border-[#F8B68B] opacity-50"></div>
                <div className="absolute w-[150px] sm:w-[200px] h-[150px] sm:h-[200px] rounded-full border border-[#F8B68B] opacity-50"></div>
              </div>

              {/* Logo */}
              <img
                src={BMLogo}
                alt="BTech Mathematics Logo"
                className="relative w-48 sm:w-64 h-48 sm:h-64 object-contain z-10"
              />
            </div>
          </div>


          {/* Right Side - Text */}
          <div data-aos="fade-left">
            <p className="text-sm uppercase tracking-wide text-orange-500 font-semibold mb-2">
              About Us
            </p>
            <h1 className="text-4xl md:text-5xl font-bricolage font-bold mb-6 text-gray-900">
              Who We Are
            </h1>
            <p className="text-gray-600 text-lg leading-relaxed">
            At BTech Mathematics, we believe mathematics should be simple, smart, and stress-free.
            We’re a passionate team of educators dedicated to helping KTU BTech students in Kerala master maths with clarity and confidence.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
